import { Input } from "basis";
import { formatAmount } from "library/moneyUtils";

export function validateNewCreditLimit(value, data): string | null {
  const error = Input.DEFAULT_PROPS.validate(value, data);

  if (error !== null) {
    return error;
  }

  const newCreditLimit = Number(value);

  if (newCreditLimit % 100 !== 0) {
    return "Must be a multiple of $100";
  }

  const {
    data: { creditLimit, maxCreditLimit, newCreditLimit: approvedCreditLimit },
  } = data;

  if (newCreditLimit - creditLimit < 100) {
    return `Must be at least $100 greater than your current credit limit of ${formatAmount(
      creditLimit,
    )}`;
  }

  if (newCreditLimit > maxCreditLimit) {
    return `Must be at most ${formatAmount(maxCreditLimit)}`;
  }

  if (newCreditLimit > approvedCreditLimit) {
    return `Must be at most ${formatAmount(approvedCreditLimit)}`;
  }

  return null;
}
